import React from "react";
import { usePublicAccess } from "../../hooks/usePublicAccess";
import { useStripeConfig } from "../../lib/stripe";
import { COLORS, SANS, MONO } from "./theme";

// The 4242 test-card hint above the card form, shown while the site is on
// Stripe TEST keys (AdminConfig → Stripe mode) so whoever is paying doesn't
// have to look up a card number. The mode comes from the server, so this can
// never suggest a test card against a live key. Renders nothing in live mode.
//
// Test mode + public access open is the combination that costs real money: the
// site is inviting strangers to pay while no payment can actually be taken, so
// that pairing gets called out explicitly on top of the card details.
export default function StripeTestCardHint() {
  const publicAccess = usePublicAccess();
  const { loading, testMode } = useStripeConfig();
  if (loading || !testMode) return null;

  return (
    <div style={styles.hint}>
      {publicAccess && (
        <p style={styles.p}>
          <strong>Heads up:</strong> the site is open to the public but Stripe is in test
          mode — no real payment can be taken.
        </p>
      )}
      <strong>Stripe test mode.</strong>
      <p style={styles.p}>Use Stripe's test card, no real charge will be made:</p>
      <div style={styles.row}>
        <span style={styles.label}>Card</span>
        <code style={styles.code}>4242 4242 4242 4242</code>
      </div>
      <div style={styles.row}>
        <span style={styles.label}>Expiry</span>
        <code style={styles.code}>Any future date</code>
      </div>
      <div style={styles.row}>
        <span style={styles.label}>CVC / ZIP</span>
        <code style={styles.code}>Any numbers</code>
      </div>
    </div>
  );
}

const styles = {
  hint: {
    background: COLORS.highlight,
    border: `1px solid ${COLORS.borderStrong}`,
    borderRadius: 10,
    padding: "14px 16px",
    fontSize: 13,
    color: COLORS.ink,
    lineHeight: 1.5,
    marginBottom: 18,
    fontFamily: SANS,
  },
  p: { margin: "6px 0 8px 0" },
  row: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "4px 0" },
  label: { color: COLORS.inkMuted, fontSize: 12 },
  code: { fontFamily: MONO, fontSize: 12.5, background: "rgba(15, 30, 45, 0.06)", padding: "2px 6px", borderRadius: 4 },
};
